const { useSelector } = require("react-redux")

export default sessionId =>
  useSelector(state =>
    state.loom.sessionId
    && state.loom.sessionId === sessionId
    && (state.loom.active || state.loom.videoData)
      ? state.loom
      : null
  )
